import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { DragDropContextProvider } from 'react-dnd';
import TouchBackend from 'react-dnd-touch-backend';
import { ToastContainer } from 'react-toastify';

import '../../styles/screens/Home.css';

import FilterBar from '../../components/FilterBar';
import Grid from '../../components/Grid';
import EmployeeBar from '../../components/EmployeeBar';

const Home = inject('employeeStore')(
  observer(
    class Home extends Component {
      render() {
        const { employeeStore } = this.props;

        employeeStore.fetchEmployees();

        return (
          <DragDropContextProvider backend={TouchBackend({ enableMouseEvents: true })}>
            <div className="App">
              <FilterBar />
              <Grid />
              <EmployeeBar />

              <ToastContainer
                position="bottom-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
              />
            </div>
          </DragDropContextProvider>
        );
      }
    }
  )
)

export default Home;



// WEBPACK FOOTER //
// ./src/screens/Home/index.js